<template>
    <div class="pages">
        <!-- 快捷栏 -->
        <shortcut-bar class="shortcut-bar page-header" />
        <div class="page-header-placeholder"></div>

        <div class="box">
            <div class="boxBreadcrumb">
                <el-breadcrumb separator-class="el-icon-arrow-right">
                    <el-breadcrumb-item :to="{ path: '/' }">{{ $t('首页') }}</el-breadcrumb-item>
                    <el-breadcrumb-item :to="{ path: '/user-center/0/my-order2' }">{{ $t('我的订单') }}</el-breadcrumb-item>
                    <!-- <el-breadcrumb-item :to="{ path: '/OrderDetail' }">订单详情</el-breadcrumb-item> -->
                    <el-breadcrumb-item>{{ $t('订单评价') }}</el-breadcrumb-item>
                </el-breadcrumb>
            </div>

            <div class="evaluate" :class="{ 'is-h5': isH5 }">
                <div class="evaluate-tit">{{ $t('评价宝贝') }}</div>
                <div class="evaluate-box" v-for="(item, index) in items">
                    <div class="evaluate-boxt">
                        <img :src="item.product_image" class="evaluate-boxt-img" alt="">
                        <div class="evaluate-boxt-right">
                            <div class="text-14">
                                <div class="margin-bottom-8">{{ item.product_title }}</div>
                                <div class="text-999">{{ item.product_sku_text }} </div>
                            </div>
                            <div class="align-center justify-between">
                                <el-rate v-model="comments[index].level"></el-rate>
                                <el-radio-group v-model="comments[index].is_anonymous">
                                    <el-radio label="0">{{ $t('公开') }}</el-radio>
                                    <el-radio label="1">{{ $t('匿名') }}</el-radio>
                                </el-radio-group>
                            </div>
                        </div>
                    </div>

                    <div class="evaluate-boxb">
                        <textarea class="evaluate-boxb-textarea" :placeholder="$t('亲，写点评价吧，你的评价对其他买家有很大的帮助的。')"
                            v-model="comments[index].content"></textarea>
                        <!-- <el-upload action="#" list-type="picture-card" :auto-upload="false">
                            <i slot="default" class="el-icon-plus"></i>
                        </el-upload> -->

                        <el-upload :action="$BASE_URL + '/api/v1/64803624da6de'" :headers="headers" :limit="9"
                            list-type="picture-card"
                            :on-remove="(file, fileList) => handleRemove(file, fileList, index)"
                            :on-success="(response, file, fileList) => handleAvatarSuccess(response, file, fileList, index)">
                            <i class="el-icon-plus"></i>
                        </el-upload>
                    </div>
                </div>
            </div>

            <div class="btn" v-if="!isH5">
                <div class="btn-l" @click="onCancel">{{ $t('取消') }}</div>
                <div class="btn-r" @click="onPublish">{{ $t('发表评论') }}</div>
            </div>
        </div>

        <div class="h5-action-bar" v-if="isH5">
            <div class="h5-btn h5-btn-cancel" @click="onCancel">{{ $t('取消') }}</div>
            <div class="h5-btn h5-btn-primary" @click="onPublish">{{ $t('发表评论') }}</div>
        </div>

        <!-- 左侧悬浮框 -->
        <div class="pc-float">
            <leftSuspension />
        </div>

        <footer-bar></footer-bar>
    </div>
</template>

<style scoped>
div /deep/ .el-upload-list--picture-card .el-upload-list__item {
    width: 72px;
    height: 72px;
}
</style>

<script>
import ShortcutBar from '@/components/ShortcutBar';
import leftSuspension from "@/components/leftSuspension.vue";
import { orderDetail, orderEvaluate } from '@/api/user';
import { getToken } from "@/utils/auth";
import footerBar from '@/components/footerBar';

export default {
    name: 'UserCenter',
    components: {
        'footer-bar': footerBar,
        'shortcut-bar': ShortcutBar,
        leftSuspension,
    },
    data() {
        return {
            value1: 0,//分数
            product_id: '',//订单ID
            items: [],//商品列表
            comments: [],//评价内容
            headers: {},//图片上传的请求头
            isH5: typeof window !== 'undefined' && window.innerWidth < 768,
        }
    },
    mounted() {
        this.updateIsH5();
        window.addEventListener('resize', this.updateIsH5);
        this.product_id = this.$route.params.id;
        this.onOrderDetail();
        this.headers = {
            'user-token': getToken()
        }
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.updateIsH5);
    },
    methods: {
        updateIsH5() {
            this.isH5 = window.innerWidth < 768;
        },
        /**图片上传 */
        handleAvatarSuccess(res, file, fileList, index) {
            let list = []
            fileList.forEach(item => {
                list.push(item.response.data.url)
            })
            this.comments[index].images = list.join(',')
        },
        /**图片移除 */
        handleRemove(file, fileList, index) {
            let list = []
            fileList.forEach(item => {
                list.push(item.response.data.url)
            })
            this.comments[index].images = list.join(',')
        },
        /**订单详情 */
        onOrderDetail() {
            orderDetail({ id: this.product_id }).then(res => {
                let data = res.data
                this.items = data.items
                let comments = []
                let items = this.items
                items.forEach(e => {
                    // console.log(e);
                    comments.push({
                        level: 5,
                        content: '',
                        images: '',
                        order_item_id: e.id,
                        is_anonymous: '1',
                    })
                })
                this.comments = comments
                // console.log(this.items);
            })
        },
        /**发表评论 */
        onPublish() {
            const hasEmpty = this.comments.some(item => !item.content || !item.content.trim());
            if (hasEmpty) {
                this.$message.warning(this.$t('请输入评价内容'));
                return;
            }

            let data = {
                id: this.product_id,
                comments: JSON.stringify(this.comments)
            }
            // console.log(data);

            orderEvaluate(data).then(res => {
                if (res.code == 1) {
                    this.$message.success(res.msg);
                    setTimeout(res => {
                        this.$router.push({ name: 'MyOrder2', params: { type: 0 } });
                    }, 1000)
                } else {
                    this.$message.warning(res.msg);
                }
            })
        },
        /**取消 */
        onCancel() {
            this.$router.go(-1)
        }
    },
};
</script>

<style scoped lang="scss">
.page-header {
    z-index: 999;
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
}

.page-header-placeholder {
    height: 56px;
}

.box {
    padding: 0 var(--page-gutter-wide);
    min-height: 80vh;
}

/*面包屑*/
.boxBreadcrumb {
    padding: 24px 0 32px 0;
}

/**评价 */
.evaluate {
    background: #FFFFFF;
    border-radius: 8px;

    .evaluate-tit {
        font-size: 16px;
        font-weight: bold;
        color: #333333;
        margin-bottom: 16px;
    }

    .evaluate-box {
        margin-bottom: 12px;

        .evaluate-boxt {
            display: flex;

            .evaluate-boxt-img {
                width: 120px;
                height: 120px;
                border-radius: 8px;
                object-fit: cover;
            }

            .evaluate-boxt-right {
                width: calc(100% - 120px);
                box-sizing: border-box;
                padding-left: 16px;
                display: flex;
                flex-direction: column;
                justify-content: space-between;
            }
        }

        .evaluate-boxb {
            margin-top: 16px;
            border: 1px solid #EEEEEE;
            padding: 16px;
            border-radius: 8px;

            .evaluate-boxb-textarea {
                width: 100%;
                height: 150px;
                resize: none;
            }
        }
    }
}

.btn {
    margin-top: 32px;
    display: flex;
    align-items: center;
    justify-content: center;

    div {
        width: 160px;
        height: 40px;
        border-radius: 4px;
        box-sizing: border-box;
        font-size: 14px;
        text-align: center;
        line-height: 40px;
        cursor: pointer;
    }

    .btn-l {
        background: #FFFFFF;
        border: 1px solid #CCCCCC;
        margin-right: 24px;
    }

    .btn-r {
        background: #000000;
        color: #FFFFFF;
        margin-left: 24px;
    }
}

@media (max-width: 767px) {
    .pages {
        overflow-x: hidden;
        width: 100%;
        background: #f5f6f8;
        padding-bottom: calc(72px + env(safe-area-inset-bottom, 0px));
    }

    .page-header {
        padding-top: env(safe-area-inset-top, 0px);
    }

    .page-header-placeholder {
        height: calc(56px + env(safe-area-inset-top, 0px));
    }

    .pc-float {
        display: none;
    }

    .box {
        padding: 0 12px 24px;
        box-sizing: border-box;
        min-height: auto;
    }

    .boxBreadcrumb {
        padding: 10px 0 12px;
        overflow-x: auto;
        white-space: nowrap;
        font-size: 12px;
    }

    .evaluate.is-h5 {
        background: transparent;
        border-radius: 0;

        .evaluate-tit {
            font-size: 15px;
            padding: 0 4px;
            margin-bottom: 12px;
        }

        .evaluate-box {
            background: #fff;
            border-radius: 8px;
            padding: 12px;
            margin-bottom: 12px;
            box-shadow: 0 2px 10px rgba(0, 0, 0, 0.06);

            .evaluate-boxt {
                .evaluate-boxt-img {
                    width: 80px;
                    height: 80px;
                    flex-shrink: 0;
                    object-fit: cover;
                }

                .evaluate-boxt-right {
                    width: calc(100% - 80px);
                    padding-left: 12px;
                    min-width: 0;

                    .text-14 {
                        font-size: 13px;
                    }

                    .align-center.justify-between {
                        flex-direction: column;
                        align-items: flex-start;
                        gap: 10px;
                    }
                }
            }

            .evaluate-boxb {
                margin-top: 12px;
                padding: 12px;
                border-radius: 8px;

                .evaluate-boxb-textarea {
                    height: 100px;
                    font-size: 14px;
                    border: none;
                    outline: none;
                    padding: 0;
                    box-sizing: border-box;
                }
            }
        }
    }

    .h5-action-bar {
        position: fixed;
        left: 0;
        right: 0;
        bottom: 0;
        z-index: 998;
        display: flex;
        align-items: center;
        gap: 12px;
        padding: 12px 16px calc(12px + env(safe-area-inset-bottom, 0px));
        background: #fff;
        box-shadow: 0 -2px 12px rgba(0, 0, 0, 0.08);
        box-sizing: border-box;

        .h5-btn {
            flex: 1;
            height: 44px;
            line-height: 44px;
            border-radius: 8px;
            font-size: 15px;
            text-align: center;
            cursor: pointer;
            box-sizing: border-box;
            transition: transform 0.15s ease, opacity 0.15s ease;
        }

        .h5-btn:active {
            transform: scale(0.98);
            opacity: 0.88;
        }

        .h5-btn-cancel {
            background: #fff;
            border: 1px solid #ccc;
            color: #333;
        }

        .h5-btn-primary {
            background: #000000;
            color: #fff;
            border: none;
        }
    }
}
</style>
<style>
.evaluate-boxb .el-upload--picture-card {
    width: 72px;
    height: 72px;
    line-height: 82px;
}
</style>



// WEBPACK FOOTER //
// src/view/order/Evaluate.vue